
import { defineComponent, type PropType } from 'vue'
import { IdfIcon } from '@invivodf/ui-kit'
import {
  C_STATUS_ICON_POSITIONS,
  C_STATUS_VALUES,
  CStatusIconPositionEnum,
  isCStatusValue,
  type CStatusIconPosition,
  type CStatusValue,
} from './statusEnum'

/**
 * Remplacement local d'`AdnStatus` (@b2ag/design-system), réduit aux 6 statuts consommés par
 * `front/seller` (cf. `statusEnum.ts`). ui-kit 0.200 n'expose pas d'équivalent — `IdfStatus`
 * n'existe qu'à partir de la ligne Vue 3.
 *
 * Correspondance des icônes du design system vers `IdfIcon` :
 * `status-active` → `check-circle-filled`, `status-upcoming` → `clock-filled`,
 * `status-past` → `hourglass-bottom-circle-filled`, `status-in-progress` → `inprogress-circle-filled`,
 * `status-shipping-in-progress` → `truck-circle-filled`.
 */
const ICONS: Record<CStatusValue, string> = {
  'offer-active': 'check-circle-filled',
  'offer-upcoming': 'clock-filled',
  'offer-past': 'hourglass-bottom-circle-filled',
  'line-item-pending': 'inprogress-circle-filled',
  'line-item-transit': 'truck-circle-filled',
  'line-item-fulfilled': 'check-circle-filled',
}

const DEFAULT_LABELS: Record<CStatusValue, string> = {
  'offer-active': 'Active',
  'offer-upcoming': 'À venir',
  'offer-past': 'Passée',
  'line-item-pending': 'En préparation',
  'line-item-transit': 'En cours de livraison',
  'line-item-fulfilled': 'Livré',
}

export default defineComponent({
  name: 'CStatus',
  components: { IdfIcon },
  props: {
    // Volontairement non contraint à `CStatusValue` : `CVariantOfferListItem` passe `''` quand
    // l'offre n'a pas de statut de validité, et `CLineItemsRow` construit `line-item-${status}`.
    status: {
      type: String,
      required: true,
      validator: (value: string) => value === '' || C_STATUS_VALUES.includes(value as CStatusValue),
    },
    label: {
      type: String,
      default: '',
    },
    iconPosition: {
      type: String as PropType<CStatusIconPosition>,
      default: CStatusIconPositionEnum.LEFT,
      validator: (value: string) => C_STATUS_ICON_POSITIONS.includes(value as CStatusIconPosition),
    },
  },
  computed: {
    icon(): string {
      return isCStatusValue(this.status) ? ICONS[this.status] : ''
    },
    defaultLabel(): string {
      return isCStatusValue(this.status) ? DEFAULT_LABELS[this.status] : ''
    },
  },
})
